/* tslint:disable */
/* eslint-disable */
/**
 * Property Management API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 3.0.2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface OfferInTag
 */
export interface OfferInTag {
    /**
     * 
     * @type {string}
     * @memberof OfferInTag
     */
    offerTag: string;
}

export function OfferInTagFromJSON(json: any): OfferInTag {
    return OfferInTagFromJSONTyped(json, false);
}

export function OfferInTagFromJSONTyped(json: any, ignoreDiscriminator: boolean): OfferInTag {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'offerTag': json['offerTag'],
    };
}

export function OfferInTagToJSON(value?: OfferInTag | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'offerTag': value.offerTag,
    };
}


